// @flow
import React, { type Node, Component } from 'react';
import {
  HeaderBlockH3,
  HeaderBlockDiv,
  HeaderTitleDiv
} from './HeaderBlockStyles';
import KnowledgeBaseLink from './KnowledgeBaseLink';
type Props = {
  title: string,
  children: Node,
  withLink?: boolean,
  to?: string
};

export default class HeaderBlock extends Component<Props> {
  render() {
    return (
      <HeaderBlockDiv>
        <HeaderTitleDiv>
          <HeaderBlockH3>{this.props.title}</HeaderBlockH3>
          {this.props.withLink && (
            <KnowledgeBaseLink to={this.props.to || ''} />
          )}
        </HeaderTitleDiv>
        {this.props.children}
      </HeaderBlockDiv>
    );
  }
}
